import { render, staticRenderFns } from "./thread-list.vue?vue&type=template&id=204a79c8&scoped=true&"
import script from "./thread-list.vue?vue&type=script&lang=js&"
export * from "./thread-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204a79c8",
  null
  
)

export default component.exports